import { ICidade } from "../../../../Interfaces/Geral/Endereco/Cidade/CidadeInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarCidadesService(idEstado: number) {
    return Service(
        Axios.get<Array<ICidade>>(
            `/home/cidades/listarcidades?idEstado=${idEstado}`
        )
    );
}

export async function GetCidadeService(nomeCidade: string) {
    return Service(
        Axios.get<ICidade>(`/home/cidades/getcidade?nomeCidade=${nomeCidade}`)
    );
}

export async function GetCidadePorIdService(idCidade: number) {
    return Service(
        Axios.get<ICidade>(`/home/cidades/getcidadeporid?idCidade=${idCidade}`)
    );
}
